const URL_PARTS = {
  de: {
    legacy: 'hey.car',
    //TODO: to be updated as heycar.com/de once DE reviews moved to i15
    current: 'hey.car',
  },
  fr: {
    legacy: 'heycar.fr',
    current: 'heycar.com/fr',
  },
  uk: {
    legacy: 'heycar.co.uk',
    current: 'heycar.com/uk',
  },
};
export const updateLegacyUrls = (input: string) => {
  return (input ?? '')
    .replaceAll(URL_PARTS.de.legacy, URL_PARTS.de.current)
    .replaceAll(URL_PARTS.fr.legacy, URL_PARTS.fr.current)
    .replaceAll(URL_PARTS.uk.legacy, URL_PARTS.uk.current);
};
